import deleteDataById from 'actions/base/deleteDataById'
import getCollection from './getCollection'

const deleteSlot = async (id) => deleteDataById(id, getCollection)

export default deleteSlot
